import i18n from 'modules/core/lib/i18n'

export const translations = () => ({
  submit: i18n.t('contract_versions.flows.promote.footer.submit'),
  submit_with_approval: i18n.t(
    'contract_versions.forms.quick_access_flows.promote.button_with_approval'
  ),
})
